class ShippingProtection extends HTMLElement {
  constructor() {
    super();
    this.checkbox = this.querySelector('.shipping-protection');
    this.variantId = '49887609913664';
    this.cartItems = document.querySelector('#cart-items');
    this.cartDrawer = this.closest('#cart-drawer');
    this.init();

    // console.log("|||||| added shipping protection");
  }

  connectedCallback() {
    // console.log("|||||| connected shipping protection");
  }

  init() {
    // console.log("|||||| checking shipping protection");
    if (this.checkbox) {
      // console.log("|||||| init shipping protection");
      this.checkbox.addEventListener('change', debounce(this.handleCheckboxChange.bind(this), 300));

      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          const protectionInCart = cart.items.some(item => item.variant_id.toString() === this.variantId);

          if (protectionInCart && cart.items.length === 1) {
            fetch('/cart/change.js', {
              method: 'POST', 
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                id: this.variantId,
                quantity: 0
              })
            })
            .then(() => {
              this.refreshCartItems();
              // this.cartDrawer.refresh();
            })
            .catch(error => console.error('Error removing protection:', error));
          } else {
            this.checkbox.checked = protectionInCart;
          }
        })
        .catch(error => console.error('Error checking cart on load:', error));
    }
  }

  handleCheckboxChange(event) {
    fetch('/cart.js')
      .then(response => response.json()) 
      .then(cart => {
        const productInCart = cart.items.some(item => item.variant_id.toString() === this.variantId);
        
        if (event.target.checked && !productInCart) {
          this.addProductVariant();
          // this.checkbox.checked = true;

        } else if (!event.target.checked && productInCart) {
          this.removeProductVariant();
          // this.checkbox.checked = false;
        }
      })
      .catch(error => console.error('Error checking cart:', error));
  }

  addProductVariant() {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ items: [{ id: this.variantId, quantity: 1 }] }),
    })
    .then(response => response.json())
    .then(data => {
      console.log('Product added:', data);
      
      this.refreshCartItems();
    })
    .catch(error => console.error('Error adding product:', error));
  }

  removeProductVariant() {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ id: this.variantId, quantity: 0 }),
    })
    .then(response => response.json())
    .then(data => {
      console.log('Product removed:', data);
      
      this.refreshCartItems();
    })
    .catch(error => console.error('Error removing product:', error));
  }

  refreshCartItems() {
    if (this.cartItems && typeof this.cartItems.refresh === 'function') {
      this.cartItems.refresh();
    } else {
      console.warn('Cart items component does not have a refresh method.');
    }
  }
}

customElements.define('shipping-protection', ShippingProtection); 